"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _clsx = _interopRequireDefault(require("clsx"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/styles");

var _core = require("@material-ui/core");

var _useRouter = _interopRequireDefault(require("../utils/useRouter"));

var _components = require("./components");

var _excluded = ["pages"],
    _excluded2 = ["title", "pages", "className", "component"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      marginBottom: theme.spacing(3)
    }
  };
});

var NavigationList = function NavigationList(props) {
  var pages = props.pages,
      rest = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/_react["default"].createElement(_core.List, null, pages.reduce(function (items, page) {
    return reduceChildRoutes(_objectSpread({
      items: items,
      page: page
    }, rest));
  }, []));
};

NavigationList.propTypes = {
  depth: _propTypes["default"].number,
  pages: _propTypes["default"].array
};

var reduceChildRoutes = function reduceChildRoutes(props) {
  var router = props.router,
      items = props.items,
      page = props.page,
      depth = props.depth;

  if (page.children) {
    var open = (0, _reactRouterDom.matchPath)(router.location.pathname, {
      path: page.href,
      exact: false
    });
    items.push( /*#__PURE__*/_react["default"].createElement(_components.NavigationListItem, {
      depth: depth,
      icon: page.icon,
      key: page.title,
      label: page.label,
      open: Boolean(open),
      title: page.title
    }, /*#__PURE__*/_react["default"].createElement(NavigationList, {
      depth: depth + 1,
      pages: page.children,
      router: router
    })));
  } else {
    items.push( /*#__PURE__*/_react["default"].createElement(_components.NavigationListItem, {
      depth: depth,
      href: page.href,
      icon: page.icon,
      key: page.title,
      label: page.label,
      title: page.title
    }));
  }

  return items;
};

var Navigation = function Navigation(props) {
  var title = props.title,
      pages = props.pages,
      className = props.className,
      Component = props.component,
      rest = _objectWithoutProperties(props, _excluded2);

  var classes = useStyles();
  var router = (0, _useRouter["default"])();
  return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, rest, {
    className: (0, _clsx["default"])(classes.root, className)
  }), title && /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    variant: "overline"
  }, title), /*#__PURE__*/_react["default"].createElement(NavigationList, {
    depth: 0,
    pages: pages,
    router: router
  }));
};

Navigation.propTypes = {
  className: _propTypes["default"].string,
  component: _propTypes["default"].any,
  pages: _propTypes["default"].array.isRequired,
  title: _propTypes["default"].string
};
Navigation.defaultProps = {
  component: "nav"
};
var _default = Navigation;
exports["default"] = _default;